import '../katapult-firebase-worker/katapult-firebase-worker.js';
import '../resizeable-div/resizeable-div.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import '../katapult-color-picker/katapult-color-picker-button.js';
import '../paper-table/paper-table.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-dialog-style.js';
import FlexForm from '../../modules/FlexForm.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { KatapultElement, html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { ToArray } from '../../modules/ToArray.js';

/* global Polymer */
class KatapultPhotoFormEditor extends KatapultEditorTemplate {
  static get template() {
    return html`
      <style include="paper-dialog-style paper-tooltip-style">
        :host {
          display: flex;
          flex-grow: 1;
          height: 100%;
          width: 100%;
          border-radius: inherit;
          overflow: hidden;
        }
        [hidden] {
          display: none !important;
        }
        #options {
          transform: translate(0);
          overflow-y: auto;
          width: 400px;
        }
        #svgWrapper {
          position: relative;
          flex-grow: 1;
          flex-shrink: 1;
          background: var(--paper-grey-200);
        }
        #svg {
          height: 100%;
          box-sizing: border-box;
        }
        #svgOverlay {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          height: 100%;
          width: 100%;
          pointer-events: none;
        }
        .header {
          background-color: var(--paper-grey-200);
          color: var(--primary-text-color-faded);
          text-transform: uppercase;
          padding: 12px;
          @apply --shadow-elevation-2dp;
        }
        .group {
          padding: 8px 16px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .group > div {
          display: flex;
          align-items: center;
          /*min-height: 48px;*/
        }
        .group > div > span {
          color: var(--primary-text-color-faded);
        }
        #header {
          display: flex;
          align-items: center;
          background-color: var(--primary-color);
          color: var(--primary-color-text-color);
          padding: 0 16px;
          flex-shrink: 0;
        }
        #header katapult-drop-down {
          --katapult-drop-down-input: {
            --paper-input-container-color: var(--primary-color-text-color-faded);
            --paper-input-container-focus-color: var(--primary-color-text-color);
          };
          --katapult-drop-down-input-color: var(--primary-color-text-color);
          --katapult-drop-down-list: {
            color: var(--primary-text-color);
          };
        }
        paper-toggle-button {
          padding: 16px 0;
          --primary-color: var(--secondary-color);
        }
        paper-toggle-button,
        katapult-color-picker-button {
          margin-left: 16px;
        }
        paper-table {
          width: 100%;
        }
        paper-table-scroll {
          padding: 4px;
        }
        paper-row.attrRow {
          height: 42px;
          border-radius: 999px;
          box-sizing: border-box;
          color: var(--primary-text-color-faded);
          background-color: white;
        }
        paper-row.attrRow paper-cell.icon {
          flex-basis: initial;
          flex-grow: 0;
          flex-shrink: 0;
          width: 48px;
        }
        paper-row.attrRow > paper-cell > span,
        paper-row.attrRow > paper-cell > paper-input {
          flex-grow: 1;
        }
        paper-row.attrRow > paper-cell > iron-icon {
          flex-shrink: 0;
        }
        paper-row.attrRow:nth-child(odd) {
          background-color: var(--paper-grey-100);
        }
        paper-slider {
          --paper-slider-active-color: var(--secondary-color);
          --paper-slider-knob-color: var(--secondary-color);
          --paper-slider-pin-color: var(--secondary-color);
          --paper-slider-font-color: var(--secondary-color-text-color);
        }
        paper-spinner-lite {
          height: 48px;
          width: 48px;
          --paper-spinner-color: var(--secondary-color);
          --paper-spinner-stroke-width: 6px;
        }
        #editor {
          display: flex;
          height: 100%;
        }
      </style>
      <katapult-firebase-worker id="files" data="{{files}}" path="[[modelSpaceDetails.path]]/models/files"></katapult-firebase-worker>
      <katapult-firebase-worker
        id="otherAttributes"
        path="[[modelSpaceDetails.path]]/models/attributes"
        data="{{otherAttributes}}"
      ></katapult-firebase-worker>
      <katapult-color-picker-dialog></katapult-color-picker-dialog>

      <div id="options">
        <template is="dom-if" if="[[_itemData]]">
          <div class="header">General Options</div>
          <div class="group">
            <div><span>Landscape</span><paper-toggle-button checked="{{landscape}}" on-click="toggleLandscape"></paper-toggle-button></div>
            <div>
              <span>Font Size</span
              ><paper-slider
                min="1"
                max="24"
                pin=""
                value="[[form.container.config.style.fontSize]]"
                on-change="fontSizeChanged"
              ></paper-slider>
            </div>
          </div>
          <div class="header">Measured Heights</div>
          <div class="group">
            <div>
              <span>Show Heights</span><paper-toggle-button checked="{{showHeights}}" on-click="toggleShowHeights"></paper-toggle-button>
            </div>
            <template is="dom-if" if="[[showHeights]]">
              <div>
                <span>Background Color</span
                ><katapult-color-picker-button
                  id="colorPicker"
                  color="[[form.$.measuredHeights.config.childStyle.background]]"
                  element="form.$.measuredHeights"
                  path="childStyle.background"
                  on-change="colorChanged"
                ></katapult-color-picker-button>
              </div>
              <template is="dom-if" if="[[allowProposed]]">
                <div>
                  <span>{{getProposedText(userGroup)}}</span
                  ><katapult-color-picker-button
                    id="colorPicker"
                    color="[[form.$.measuredHeights.config.childStyle._proposedBackground]]"
                    element="form.$.measuredHeights"
                    path="childStyle._proposedBackground"
                    on-change="colorChanged"
                  ></katapult-color-picker-button>
                </div>
              </template>
              <div>
                <span>Text Color</span
                ><katapult-color-picker-button
                  id="colorPicker"
                  color="[[form.$.measuredHeights.config.childStyle.color]]"
                  element="form.$.measuredHeights"
                  path="childStyle.color"
                  on-change="colorChanged"
                ></katapult-color-picker-button>
              </div>
              <template is="dom-if" if="[[companyModules.make_ready]]">
                <div>
                  <span>Show Make Ready View</span
                  ><paper-toggle-button checked="[[showMrView]]" on-tap="toggleShowMrView"></paper-toggle-button>
                </div>
                <div>
                  <span>Show MR Violations</span
                  ><paper-toggle-button checked="[[showMrViolations]]" on-click="toggleShowMrViolations"></paper-toggle-button>
                </div>
              </template>
              <template is="dom-if" if="[[showMrViolations]]">
                <div>
                  <span>MR Violation Background Color</span
                  ><katapult-color-picker-button
                    id="colorPicker"
                    color="{{form.$.measuredHeights.config.childStyle._mrViolationBackground}}"
                    element="form.$.measuredHeights"
                    path="childStyle._mrViolationBackground"
                    on-change="colorChanged"
                  ></katapult-color-picker-button>
                </div>
                <div>
                  <span>MR Violation Text Color</span
                  ><katapult-color-picker-button
                    id="colorPicker"
                    color="{{form.$.measuredHeights.config.childStyle._mrViolationColor}}"
                    element="form.$.measuredHeights"
                    path="childStyle._mrViolationColor"
                    on-change="colorChanged"
                  ></katapult-color-picker-button>
                </div>
              </template>
              <div>
                <span>Show Down Guy Lead Length</span
                ><paper-toggle-button checked="[[showDownGuyLeadLength]]" on-tap="toggleShowDownGuyLeadLength"></paper-toggle-button>
              </div>
              <div>
                <span> Show Arm Markers </span>
                <paper-toggle-button name="arm" checked="[[showArms]]" on-tap="toggleInputOnForm"></paper-toggle-button>
              </div>
              <div>
                <span> Show Insulator Markers </span>
                <paper-toggle-button name="insulator" checked="[[showInsulators]]" on-tap="toggleInputOnForm"></paper-toggle-button>
              </div>
              <template is="dom-if" if="[[showPhaselinkMrOption(userGroup)]]">
                <div>
                  <span>Include Extra MR Text</span
                  ><paper-toggle-button checked="[[includeExtraMrText]]" on-tap="toggleIncludeExtraMrText"></paper-toggle-button>
                </div>
              </template>
            </template>
          </div>
          <div class="header">Page Info</div>
          <div class="group">
            <div>
              <span>Background Color</span
              ><katapult-color-picker-button
                id="colorPicker"
                color="[[form.$.pageInfo.config.style.background]]"
                element="form.$.pageInfo"
                path="style.background"
                on-change="colorChanged"
              ></katapult-color-picker-button>
            </div>
            <div>
              <span>Text Color</span
              ><katapult-color-picker-button
                id="colorPicker"
                color="[[form.$.pageInfo.config.style.color]]"
                element="form.$.pageInfo"
                path="style.color"
                on-change="colorChanged"
              ></katapult-color-picker-button>
            </div>
            <div>
              <span>Show Fore/Back Span Heights</span
              ><paper-toggle-button checked="[[showForeBackSpanHeights]]" on-tap="toggleShowForeBackSpanHeights"></paper-toggle-button>
            </div>
            <katapult-drop-down
              name="page_info_item"
              label="Add Text Item"
              items="[[filteredAttributesArray]]"
              label-path="name"
              no-label-float=""
              element="form.$.pageInfo"
              on-selected-changed="addAttribute"
            ></katapult-drop-down>
            <paper-table>
              <paper-table-scroll element="form.$.pageInfo" on-sort-changed="attributeSortChanged">
                <template is="dom-repeat" items="[[form.$.pageInfo.children]]" as="child">
                  <paper-row class="attrRow" slot="sortable">
                    <paper-cell drag-handle="" class="icon">
                      <iron-icon icon="katapult-misc:drag-indicator"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <template is="dom-if" if="[[equal(child.content.config.interpret, 'plain')]]">
                        <paper-input
                          label="[[child.content.config.label]]"
                          value="[[child.content.config.value]]"
                          on-change="editAttribute"
                          no-label-float=""
                        ></paper-input>
                      </template>
                      <template is="dom-if" if="[[!equal(child.content.config.interpret, 'plain')]]">
                        <span>[[child.content.config.label]]</span>
                        <template is="dom-if" if="[[isLocationAttribute(child.content.config)]]">
                          <iron-icon style="align-self: flex-end" icon="communication:location-on"></iron-icon>
                        </template>
                      </template>
                    </paper-cell>
                    <paper-cell class="icon">
                      <iron-icon icon="clear" element="form.$.pageInfo" on-click="removeAttribute"></iron-icon>
                    </paper-cell>
                  </paper-row>
                </template>
              </paper-table-scroll>
            </paper-table>
          </div>
          <div class="header">Attribute Info</div>
          <div class="group">
            <div>
              <span>Background Color</span
              ><katapult-color-picker-button
                id="colorPicker"
                color="[[form.$.itemInfo.config.style.background]]"
                element="form.$.itemInfo"
                path="style.background"
                on-change="colorChanged"
              ></katapult-color-picker-button>
            </div>
            <div>
              <span>Text Color</span
              ><katapult-color-picker-button
                id="colorPicker"
                color="[[form.$.itemInfo.config.style.color]]"
                element="form.$.itemInfo"
                path="style.color"
                on-change="colorChanged"
              ></katapult-color-picker-button>
            </div>
            <katapult-drop-down
              label="Add Text Item"
              items="[[filteredAttributesArray]]"
              label-path="name"
              no-label-float=""
              element="form.$.itemInfo"
              on-selected-changed="addAttribute"
            ></katapult-drop-down>
            <paper-table>
              <paper-table-scroll element="form.$.itemInfo" on-sort-changed="attributeSortChanged">
                <template is="dom-repeat" items="{{form.$.itemInfo.children}}" as="child">
                  <paper-row class="attrRow" slot="sortable">
                    <paper-cell class="icon">
                      <iron-icon icon="katapult-misc:drag-indicator"></iron-icon>
                    </paper-cell>
                    <paper-cell>
                      <template is="dom-if" if="[[equal(child.content.config.interpret, 'plain')]]">
                        <paper-input
                          label="[[child.content.config.label]]"
                          value="[[child.content.config.value]]"
                          on-change="editAttribute"
                          no-label-float=""
                        ></paper-input>
                      </template>
                      <template is="dom-if" if="[[!equal(child.content.config.interpret, 'plain')]]">
                        <span>[[child.content.config.label]]</span>
                        <template is="dom-if" if="[[isLocationAttribute(child.content.config)]]">
                          <iron-icon style="align-self: flex-end" icon="communication:location-on"></iron-icon>
                        </template>
                      </template>
                    </paper-cell>
                    <paper-cell class="icon">
                      <iron-icon icon="clear" element="form.$.itemInfo" on-click="removeAttribute"></iron-icon>
                    </paper-cell>
                  </paper-row>
                </template>
              </paper-table-scroll>
            </paper-table>
          </div>
          <div class="header">LOGO</div>
          <div class="group">
            <katapult-drop-down items="[[files]]" label="Logo" label-path="name" value-path="$key" value="{{logoKey}}"></katapult-drop-down>
            <span style="font-size: 10pt; color: var(--primary-text-color-faded);">Files can be managed from the Files tab</span>
          </div>
        </template>
      </div>
      <div id="svgWrapper">
        <div id="svgOverlay">
          <paper-spinner-lite active="[[rendering]]"></paper-spinner-lite>
        </div>
        <div id="svg"></div>
      </div>
    `;
  }

  static get properties() {
    return {
      allowProposed: {
        type: Boolean,
        value: false
      },
      filteredAttributesArray: {
        computed: 'getFilteredAttributesArray(otherAttributes)'
      }
    };
  }
  static get observers() {
    return [
      '_computeShouldAllowProposed(userGroup)',
      'heightsChildStyleChanged(form.$.measuredHeights.config.childStyle.*)',
      'logoKeyChanged(logoKey)'
    ];
  }

  getDefaultFormModel() {
    let formJSON = {
      children: [
        {
          children: [
            {
              content: {
                id: 'mainPhoto',
                interpret: 'computed',
                type: 'image',
                value: 'main_photo'
              },
              style: {
                flex: 1
              }
            }
          ],
          style: {
            height: 'inherit',
            position: 'absolute',
            width: 700
          }
        },
        {
          children: [
            {
              id: 'measuredHeights',
              childStyle: {
                _proposedBackground: '#008EA6',
                background: '#007299',
                color: 'rgba(255,255,255,1)',
                height: 'content',
                left: 0,
                padding: 5
              },
              lineExtension: 20,
              style: {
                borderRadius: 'inherit',
                flex: 'content',
                margin: 5,
                opacity: 1,
                minFlex: 1
              },
              target: 'mainPhoto',
              type: 'measured_heights',
              warning_dialog: 'measuredHeightsWarningDialog'
            },
            {
              id: 'measuredHeightsWarningDialog',
              style: {
                background: '#007299',
                borderRadius: 'inherit',
                color: 'rgba(255,255,255,1)',
                height: 'content',
                margin: 5,
                marginTop: 0,
                padding: 5,
                display: 'none'
              }
            },
            {
              id: 'itemInfo',
              children: [
                {
                  content: {
                    interpret: 'plain',
                    type: 'text',
                    value: 'POLE INFO'
                  },
                  style: {
                    fontWeight: 'bold',
                    height: 'content',
                    margin: 2
                  }
                },
                {
                  content: {
                    attribute: true,
                    interpret: 'computed',
                    type: 'text',
                    value: 'scid'
                  },
                  style: {
                    height: 'content',
                    margin: 1
                  }
                },
                {
                  content: {
                    interpret: 'computed',
                    label: 'pole_tag',
                    type: 'text',
                    value: 'pole_tag'
                  },
                  style: {
                    fontWeight: 'normal',
                    height: 'content',
                    margin: 2
                  }
                },
                {
                  content: {
                    attribute: true,
                    interpret: 'computed',
                    type: 'text',
                    value: 'pole_spec'
                  },
                  style: {
                    height: 'content',
                    margin: 1
                  }
                }
              ],
              style: {
                background: '#007299',
                borderRadius: 'inherit',
                bottom: 0,
                color: '#fff',
                flex: 'content',
                margin: 5,
                maxHeight: 'content',
                padding: 8
              }
            }
          ],
          style: {
            flexDirection: 'column',
            height: 950,
            paddingRight: 20,
            paddingTop: 20,
            position: 'absolute',
            right: 0,
            width: 250
          }
        },
        {
          children: [
            {
              id: 'pageInfo',
              children: [
                {
                  content: {
                    interpret: 'computed',
                    type: 'text',
                    value: 'job_name'
                  },
                  style: {
                    fontWeight: 'bold',
                    height: 'content',
                    margin: 2
                  }
                },
                {
                  content: {
                    interpret: 'computed',
                    type: 'text',
                    value: 'page_number'
                  },
                  style: {
                    height: 'content',
                    margin: 2
                  }
                }
              ],
              style: {
                background: '#007299',
                borderRadius: 'inherit',
                color: '#fff',
                padding: 8
              }
            }
          ],
          style: {
            height: 950,
            left: 0,
            padding: 20,
            position: 'absolute',
            top: 0,
            width: 200
          }
        },
        {
          id: 'logoContainer',
          children: [
            {
              id: 'logo',
              content: {
                fill: 'fit',
                type: 'image',
                value: {}
              },
              style: {
                flex: 3
              }
            }
          ],
          style: {
            bottom: 0,
            height: 150,
            padding: 20,
            position: 'absolute',
            right: 0,
            width: 150
          }
        }
      ],
      style: {
        backgroundColor: 'white',
        borderRadius: 12,
        color: 'white',
        fontFamily: 'Helvetica',
        fontSize: 12,
        height: 1100,
        width: 850
      }
    };

    return formJSON;
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    let compute = {
      text: (config) => {
        return `${CamelCase(config.value)}: ###`;
      },
      image: (config) => {
        return 'https://storage.googleapis.com/katapult-pro-shared-files/photos/pole_out_front.jpg';
      },
      measured_heights: (config) => {
        let label = '20\'-9" Proposed Telephone Company Telco Com';
        if (this.userGroup == 'alpine_communication_corp') label = '20\'-9" Permitted Telephone Company Telco Com';
        let proposedHeight = {
          height: 249.3,
          label: label,
          manual: false,
          percentY: 45.6449492012789,
          percentX: 50.50631753667355,
          n: 1,
          proposed: true
        };

        let heights = [
          {
            height: 263.06,
            label: '21\'-11" Telephone Company Telco Com',
            manual: false,
            percentY: 43.60083655684523,
            percentX: 50.61629133482952,
            n: 1
          },
          {
            height: 280.14,
            label: '23\'-4" Telephone Company Telco Com',
            manual: false,
            percentY: 41.06981165138816,
            percentX: 50.52589758820607,
            n: 1
          },
          {
            height: 280.32,
            label: '23\'-4" Fiber Company Fiber Optic Com',
            manual: false,
            percentY: 41.04317800121849,
            percentX: 50.44496581744845,
            n: 1
          },
          {
            height: 293.39,
            label: '24\'-5" Cable Company CATV Com',
            mrViolations: true,
            manual: false,
            percentY: 39.10976203715037,
            percentX: 50.5658043152027,
            n: 1
          },
          {
            height: 328.77,
            label: '27\'-5" Power Company Riser Electrical 4" Riser',
            manual: false,
            percentY: 33.8954582248381,
            percentX: 49.195469939177876,
            n: 1
          },
          {
            height: 345.66,
            label: '28\'-10" Power Company Power Drop',
            manual: false,
            percentY: 31.416386322530247,
            percentX: 50.35490026662711,
            n: 1
          },
          {
            height: 345.89,
            label: '28\'-10" Power Company Neutral',
            manual: false,
            percentY: 31.38322973123072,
            percentX: 50.34847032990067,
            n: 1
          },
          {
            height: 351.67,
            label: '29\'-4" Power Company Transformer Bottom Of Equipment 1PH-25KVA',
            manual: false,
            percentY: 30.535165885633912,
            percentX: 50.521126795293455,
            n: 1
          },
          {
            height: 375.28,
            label: '31\'-3" Power Company Transformer Top Bolt',
            manual: false,
            percentY: 27.083247699973896,
            percentX: 50.63247899483089,
            n: 1
          },
          {
            height: 445.95,
            label: '37\'-2" Power Company Primary',
            manual: false,
            percentY: 16.817911129018235,
            percentX: 50.32968452623876,
            n: 1
          },
          {
            height: 449.79,
            label: '37\'-6" Pole Top',
            manual: false,
            percentY: 16.262914697932235,
            percentX: 50.42100043696236,
            n: 1
          }
        ];

        if (!this.showMrView || this.userGroup == 'alpine_communication_corp') {
          heights.splice(0, 0, proposedHeight);
        }
        return heights;
      },

      mr_heights: (config) => {
        let label = '20\'-9" Proposed Telephone Company';
        if (this.userGroup == 'alpine_communication_corp') label = '20\'-9" Permitted Telephone Company';
        return [
          {
            height: 249.3,
            label: label,
            manual: false,
            percentY: 45.6449492012789,
            percentX: 50.50631753667355,
            n: 1,
            proposed: true
          },
          {
            height: 263.06,
            label: 'Telephone Company +5" (22\'-4")',
            manual: false,
            percentY: 43.60083655684523,
            percentX: 50.61629133482952,
            movedPercentY: 42.60083655684523,
            n: 1
          }
        ];
      }
    };

    this.form = new FlexForm({}, this.$.svg, { compute });
    this.form.on('config-changed', () => {
      this.set('_itemData.model', this.form.getConfig());
      this.render();
    });
  }
  async _computeShouldAllowProposed() {
    // Get the user's allowed Katapult Pro modules
    const modules = await FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/subscription/modules`)
      .once('value')
      .then((s) => s.val());

    // Convert the user's allowed modules to an array
    const userModules = Object.keys(modules || {}).filter((x) => modules[x] === true);

    // If the company has at least the Pole Attachments module, allow adding proposed traces
    this.allowProposed =
      userModules.includes('pole_attachments_unpaid') ||
      userModules.includes('pole_attachments') ||
      userModules.includes('make_ready') ||
      userModules.includes('pole_loading_exports') ||
      userModules.includes('integrated_pole_loading') ||
      false;
  }

  isLocationAttribute(childConfig) {
    const locationAttributes = ['latitude', 'longitude'];
    return locationAttributes.includes(childConfig.value) && !childConfig.attribute;
  }

  addAttribute(e) {
    if (e.detail.selectedItem) {
      let path = e.currentTarget.getAttribute('path');
      let interpret = e.detail.selectedItem.plain ? 'plain' : 'computed';
      let value = e.detail.selectedItem.plain ? '' : e.detail.selectedItem.key;
      let fontWeight = e.detail.selectedItem.bold ? 'bold' : 'normal';
      let attribute = e.detail.selectedItem.attribute || null;
      let child = {
        content: {
          label: e.detail.selectedItem.name,
          interpret,
          value,
          attribute,
          type: 'text'
        },
        style: {
          height: 'content',
          margin: 2,
          fontWeight
        }
      };

      let elementPath = e.currentTarget.getAttribute('element');
      let element = this.get(elementPath);
      element.addChild(child, true);
      this.notifySplices(`${elementPath}.children`, [
        { index: element.children.length - 1, removed: [], addedCount: 1, object: element.children, type: 'splice' }
      ]);
      e.currentTarget.clear();
    }
  }
  attributeSortChanged(e) {
    let elementPath = e.currentTarget.getAttribute('element');
    let element = this.get(elementPath);
    let removed = element.children.splice(e.detail.prevIndex, 1);
    this.notifySplices(`${elementPath}.children`, [
      { index: e.detail.prevIndex, removed, addedCount: 0, object: element.children, type: 'splice' }
    ]);
    element.children.splice(e.detail.index, 0, removed[0]);
    this.notifySplices(`${elementPath}.children`, [
      { index: element.children.length - 1, removed: [], addedCount: 1, object: element.children, type: 'splice' }
    ]);
    element.root._fire('config-changed');
  }
  colorChanged(e) {
    let element = this.get(e.currentTarget.getAttribute('element'));
    let path = e.currentTarget.getAttribute('path');
    element.setConfig(path, e.detail.color);

    // Also update the mrHeights if needed
    if (element.config.id == 'measuredHeights') {
      if (['childStyle.background', 'childStyle._proposedBackground', 'childStyle.color'].includes(path)) {
        this.form.$.mrHeights.setConfig(path, e.detail.color);
      }
    }
  }
  _itemDataChanged() {
    super._itemDataChanged.apply(this, arguments);
    if (this.get('_itemData.model') == null) {
      this.set('_itemData.model', this.getDefaultFormModel());
    } else {
      this.setConfig();
      // If this is Katapult and the "Powered by Katapult" is missing, add it.
      if (
        SquashNulls(window.config, 'firebaseData', 'name').toLowerCase().includes('katapult') &&
        !this.form.$.poweredByKatapult &&
        this.form.$.logoContainer &&
        !this.form.$.logoContainer.children.some((x) => SquashNulls(x, 'content', 'config', 'value', 'url').includes('powered_by_katapult'))
      ) {
        this.form.$.logoContainer.addChild({
          id: 'poweredByKatapult',
          content: {
            fill: 'fit',
            type: 'image',
            value: {
              url: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/powered_by_katapult.png?useFromCache=false',
              fetchOptions: { mode: 'cors' }
            }
          },
          style: {
            flex: 1
          }
        });
      }

      this.logoKey = this.get('form.container.config.logoFileKey');
      this.landscape = this.get('form.container.config.landscape') ? true : false;
      this.showMrView = this.get('form.$.mrHeights') ? true : false;
      this.showMrViolations = this.get('form.$.measuredHeights.config.showMrViolations') ? true : false;
      this.showDownGuyLeadLength = this.get('form.$.measuredHeights.config.showDownGuyLeadLength') ? true : false;
      this.includeExtraMrText = this.get('form.$.measuredHeights.config.includeExtraMrText') ? true : false;
      this.showHeights = this.get('form.$.measuredHeights.config.style.opacity') ? true : false;
      this.showForeBackSpanHeights = this.get('form.$.backSpan') ? true : false;
      this.showArms = this.get('form.$.measuredHeights.config.additionalPhotoInputs')?.includes('arm') || false;
      this.showInsulators = this.get('form.$.measuredHeights.config.additionalPhotoInputs')?.includes('insulator') || false;
      this.render();
    }
  }
  editAttribute(e) {
    let container = e.model.child;
    container.content.setConfig('value', e.currentTarget.value);
  }
  equal(a, b) {
    return a == b;
  }
  fontSizeChanged(e) {
    this.form.container.setConfig('style.fontSize', e.currentTarget.value);
  }
  getFilteredAttributesArray() {
    /**
     * @typedef PhotoFromAttributeObject
     * @property {string} key - The key of the attribute
     * @property {string} name - The name of the attribute
     * @property {boolean} [attribute] - Whether the attribute is an attribute or not
     * @property {boolean} [plain] - Whether the attribute is plain text or not
     * @property {boolean} [bold] - Whether the attribute is bold or not
     * @property {string[]} [icons] - The icons to display next to the attribute
     * */

    /** @type {PhotoFromAttributeObject[]} */
    let filtered = ToArray(this.otherAttributes)
      .filter((x) => x.attribute_types && ['node', 'section'].some((y) => x.attribute_types.includes(y)))
      .map((x) => ({ key: x.$key, name: CamelCase(x.$key), attribute: x.$key !== 'pole_tag' }));
    filtered.unshift({ key: 'page_number', name: 'Page Number' });
    filtered.unshift({ key: 'job_name', name: 'Job Name' });
    filtered.unshift({ key: 'date_taken', name: 'Date Taken' });
    filtered.unshift({ key: 'make_ready_notes', name: 'Make Ready Notes' });
    filtered.unshift({ key: 'latitude', name: 'Latitude', icons: ['communication:location-on'] });
    filtered.unshift({ key: 'longitude', name: 'Longitude', icons: ['communication:location-on'] });
    filtered.unshift({ key: 'bold_text', name: 'Bold Text', plain: true, bold: true });
    filtered.unshift({ key: 'text', name: 'Text', plain: true });
    return filtered;
  }
  heightsChildStyleChanged() {
    this.set('_itemData.model.children.1.children.1.style.background', this.get('form.$.measuredHeights.config.childStyle.background'));
    this.set('_itemData.model.children.1.children.1.style.color', this.get('form.$.measuredHeights.config.childStyle.color'));
  }
  labelChanged(label) {
    this.set('_itemData.name', label);
  }
  async logoKeyChanged() {
    this.form.container.setConfig('logoFileKey', this.logoKey, { silent: true });
    if (this.form && this.form.$.logo) {
      if (this.logoKey) {
        try {
          let url = await firebase
            .storage()
            .ref(`company_files/${this.userGroup}/${this.logoKey}`)
            .getDownloadURL()
            .then((x) => x + '&useFromCache=false');
          this.form.$.logo.content.setConfig('value', { url, fetchOptions: { mode: 'cors' } });
        } catch (e) {
          console.warn('Failed to load logo');
        }
      } else {
        this.form.$.logo.content.setConfig('value', null);
      }
    }
  }
  removeAttribute(e) {
    let elementPath = e.currentTarget.getAttribute('element');
    let element = this.get(elementPath);
    let child = element.removeChild(e.model.index, true);
    this.notifySplices(`${elementPath}.children`, [
      { index: e.model.index, removed: [child], addedCount: 0, object: element.children, type: 'splice' }
    ]);
  }

  toggleInputOnForm(e) {
    // get the type of toggle to determine what element to add
    let elementType = e.currentTarget?.name;
    // determine if it was toggled on or off
    let toggledValue = e.currentTarget?.checked;
    // add or subtract the input type from the list of inputs type for the form's config
    let currentMeasuredHeightsInputs = this.form.$.measuredHeights?.config?.additionalPhotoInputs || [];
    if (toggledValue) {
      // add the element type to the measured heights inputs if it's not already there
      if (!currentMeasuredHeightsInputs.includes(elementType)) {
        currentMeasuredHeightsInputs.push(elementType);
        this.form.$.measuredHeights.setConfig('additionalPhotoInputs', currentMeasuredHeightsInputs);
      }
    } else {
      // remove the element type from the measured heights inputs
      if (currentMeasuredHeightsInputs.includes(elementType)) {
        currentMeasuredHeightsInputs.splice(currentMeasuredHeightsInputs.indexOf(elementType), 1);
        if (currentMeasuredHeightsInputs.length == 0) this.form.$.measuredHeights.setConfig('additionalPhotoInputs', null);
        else this.form.$.measuredHeights.setConfig('additionalPhotoInputs', currentMeasuredHeightsInputs);
      }
    }
  }

  setConfig() {
    if (this._itemData) {
      this.form.setConfig(this._itemData.model);
      // Notify that element id lookup has been changed.
      this.notifyPath('form.$');
    }
  }
  async render() {
    this._renderDebouncer = Debouncer.debounce(this._renderDebouncer, timeOut.after(10), async () => {
      // this.set('_itemData.model', this.form.getConfig());

      if (!this.rendering) {
        this.rendering = true;
        this.form.initialize();
        await this.form.computeContent();
        this.form.render();
        this.rendering = false;
        if (this.reRender) {
          this.reRender = false;
          await this.render();
        }
      } else {
        this.reRender = true;
      }
    });
  }

  getProposedText(userGroup) {
    return userGroup == 'alpine_communication_corp' ? 'Permitted Background Color' : 'Proposed Background Color';
  }

  showPhaselinkMrOption(userGroup) {
    return userGroup.toLowerCase().includes('phaselink');
  }

  toggleIncludeExtraMrText(e) {
    this.includeExtraMrText = !this.includeExtraMrText;
    this.form.$.measuredHeights.setConfig('includeExtraMrText', this.includeExtraMrText);
  }

  toggleShowDownGuyLeadLength(e) {
    this.showDownGuyLeadLength = !this.showDownGuyLeadLength;
    this.form.$.measuredHeights.setConfig('showDownGuyLeadLength', this.showDownGuyLeadLength);
  }

  toggleShowHeights(e) {
    e.preventDefault();
    this.form.$.measuredHeights.setConfig('style.opacity', this.showHeights ? 1 : 0);
  }

  toggleShowForeBackSpanHeights(e) {
    this.showForeBackSpanHeights = !this.showForeBackSpanHeights;
    if (this.showForeBackSpanHeights) {
      this._itemData.model.children.push(
        {
          children: [
            {
              id: 'backSpan',
              children: [
                {
                  content: {
                    backSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'back_span'
                  },
                  style: {
                    fontWeight: 'bold',
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    backSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'lowest_power'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    backSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'lowest_comm'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    backSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'proposed'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                }
              ],
              style: {
                background: '#007299',
                borderRadius: 'inherit',
                color: '#fff',
                flexDirection: 'column',
                padding: 8,
                width: 200
              }
            }
          ],
          style: {
            bottom: 0,
            height: 150,
            left: 0,
            padding: 20,
            position: 'absolute',
            width: 250
          }
        },
        {
          children: [
            {
              id: 'foreSpan',
              children: [
                {
                  content: {
                    foreSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'fore_span'
                  },
                  style: {
                    fontWeight: 'bold',
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    foreSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'lowest_power'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    foreSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'lowest_comm'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                },
                {
                  content: {
                    foreSpan: 'true',
                    interpret: 'computed',
                    type: 'text',
                    value: 'proposed'
                  },
                  style: {
                    height: 'content',
                    margin: 2,
                    width: '100%'
                  }
                }
              ],
              style: {
                background: '#007299',
                borderRadius: 'inherit',
                color: '#fff',
                flexDirection: 'column',
                padding: 8,
                width: 200
              }
            }
          ],
          style: {
            bottom: 0,
            height: 150,
            padding: 20,
            position: 'absolute',
            right: 140,
            width: 250
          }
        }
      );
      this._itemDataChanged();
    } else {
      this._itemData.model.children.splice(-2, 2);
      this._itemDataChanged();
    }
    this.form.$.measuredHeights.setConfig('showForeBackSpanHeights', this.showForeBackSpanHeights);
  }

  toggleShowMrView(e) {
    this.showMrView = !this.showMrView;
    if (this.showMrView) {
      this._itemData.model.children[2].style.width = 250;
      this._itemData.model.children[2].children.push({
        id: 'mrHeights',
        childStyle: {
          _proposedBackground: this.form.$.measuredHeights.config.childStyle._proposedBackground || '#008EA6',
          background: this.form.$.measuredHeights.config.childStyle.background || '#007299',
          color: this.form.$.measuredHeights.config.childStyle.color || 'rgba(255,255,255,1)',
          height: 'content',
          left: 0,
          padding: 5
        },
        lineExtension: 20,
        showMrViolations: this.showMrViolations,
        style: {
          borderRadius: 'inherit',
          flex: 'content',
          margin: 5,
          opacity: 1,
          minFlex: 1
        },
        target: 'mainPhoto',
        type: 'mr_heights'
      });
      this._itemDataChanged();
    } else {
      this._itemData.model.children[2].style.width = 200;
      this._itemData.model.children[2].children.splice(1, 1);
      this._itemDataChanged();
    }
    this.form.$.measuredHeights.setConfig('showMrView', this.showMrView);
  }

  toggleShowMrViolations(e) {
    this.showMrViolations = !this.showMrViolations;
    this.form.$.measuredHeights.setConfig('showMrViolations', this.showMrViolations);
    if (this.form.$.mrHeights) {
      this.form.$.mrHeights.setConfig('showMrViolations', this.showMrViolations);
    }
  }

  toggleLandscape(e) {
    if (this.landscape) {
      this._itemData.model.style.height = 850;
      this._itemData.model.style.width = 1100;
      this._itemData.model.children[0].children[0].content.fill = 'fit';
      this._itemData.model.children[0].style.width = 905;
      this._itemData.model.children[1].style.height = 700;
      this._itemData.model.children[2].style.height = 'inherit';
      this._itemData.model.children[3].style.right = 20;
      this._itemData.model.landscape = true;
      this._itemDataChanged();
    } else {
      this._itemData.model.style.height = 1100;
      this._itemData.model.style.width = 850;
      this._itemData.model.children[0].children[0].content.fill = null;
      this._itemData.model.children[0].style.width = 700;
      this._itemData.model.children[1].style.height = 950;
      this._itemData.model.children[2].style.height = 950;
      this._itemData.model.children[3].style.right = 0;
      this._itemData.model.landscape = false;
      this._itemDataChanged();
    }
  }
}
window.customElements.define('katapult-photo-form-editor', KatapultPhotoFormEditor);
